export default ({ address, lat, lng }) => (
  `https://www.google.com/maps/search/${encodeURIComponent(address)}/@${lat},${lng}z`
)
